(function () {
    "use strict";

    var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    /* ---------- Scroll reveal ---------- */
    function initScrollReveal() {
    var sections = document.querySelectorAll("main .shopify-section");
    if (!sections.length) return;

    var vh = window.innerHeight;

    sections.forEach(function (section) {
    var rect = section.getBoundingClientRect();
    if (rect.top < vh * 0.85) return;
    section.setAttribute("data-scroll-reveal", "");
    });

    if (reduceMotion || !("IntersectionObserver" in window)) return;

    var observer = new IntersectionObserver(
    function (entries) {
    entries.forEach(function (entry) {
    if (entry.isIntersecting) {
    entry.target.classList.add("is-revealed");
    observer.unobserve(entry.target);
    }
    });
    },
    { threshold: 0.15, rootMargin: "0px 0px -8% 0px" }
    );

    document.querySelectorAll("[data-scroll-reveal]").forEach(function (el) {
    observer.observe(el);
    });
    }

    /* ---------- Matcha cup cursor ---------- */
    function initMatchaCursor() {
    if (reduceMotion) return;
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;

    var cursor = document.createElement("div");
    cursor.id = "matcha-cursor";
    cursor.innerHTML = '<div class="matcha-cursor__shape">🍵</div>';
    document.body.appendChild(cursor);
    document.documentElement.classList.add("matcha-cursor-on");

    var x = window.innerWidth / 2,
    y = window.innerHeight / 2,
    curX = x,
    curY = y;

    function loop() {
    curX += (x - curX) * 0.2;
    curY += (y - curY) * 0.2;
    cursor.style.transform = "translate(" + curX + "px, " + curY + "px)";
    requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);

    window.addEventListener("mousemove", function (e) {
    x = e.clientX;
    y = e.clientY;
    cursor.classList.add("is-visible");
    });

    document.addEventListener("mouseleave", function () {
    cursor.classList.remove("is-visible");
    });

    window.addEventListener("mousedown", function () {
    cursor.classList.add("is-active");
    });
    window.addEventListener("mouseup", function () {
    cursor.classList.remove("is-active");
    });

    var interactiveSelector = "a, button, input, textarea, select, summary, [role='button']";
    document.addEventListener("mouseover", function (e) {
    if (e.target.closest(interactiveSelector)) {
    cursor.classList.add("is-pointer");
    }
    });
    document.addEventListener("mouseout", function (e) {
    if (e.target.closest(interactiveSelector)) {
    cursor.classList.remove("is-pointer");
    }
    });
    }

    /* ---------- Typewriter heading ---------- */
    function initTypewriter() {
    var heading = null;
    var candidates = document.querySelectorAll("h1, h2, h3, h4, h5, h6");
    for (var i = 0; i < candidates.length; i++) {
    var t = candidates[i].textContent.trim().toLowerCase();
    if (t.indexOf("collectible matcha beads") !== -1) {
    heading = candidates[i];
    break;
    }
    }
    if (!heading) return;
    
    var fullText = heading.textContent;
    heading.setAttribute("data-typewriter", "");
    
    if (reduceMotion) return;
    
    heading.textContent = "";
    heading.classList.add("is-typing");
    
    var charIndex = 0;
    function typeNext() {
    if (charIndex <= fullText.length) {
    heading.textContent = fullText.slice(0, charIndex);
    charIndex++;
    setTimeout(typeNext, 55);
    } else {
    heading.classList.remove("is-typing");
    }
    }
    typeNext();
    }
    
    /* ---------- Falling matcha powder (click effect) ---------- */
    function initMatchaPowderClick() {
    if (reduceMotion) return;
    
    function spawnPowderParticle(x, y) {
    var particle = document.createElement("div");
    particle.className = "matcha-powder-particle";
    
    var size = 4 + Math.random() * 6;
    particle.style.width = size + "px";
    particle.style.height = size + "px";
    particle.style.left = x + "px";
    particle.style.top = y + "px";
    document.body.appendChild(particle);
    
    var offsetX = (Math.random() - 0.5) * 60;
    var fallDistance = 120 + Math.random() * 160;
    var duration = 500 + Math.random() * 400;
    var rotate = Math.random() * 360;
    
    var anim = particle.animate(
    [
    { transform: "translate(0px, 0px) rotate(0deg)", opacity: 1 },
    { transform: "translate(" + offsetX + "px, " + fallDistance + "px) rotate(" + rotate + "deg)", opacity: 0 }
    ],
    { duration: duration, easing: "cubic-bezier(0.34, 0.2, 0.64, 1)" }
    );
    
    anim.onfinish = function () {
    particle.remove();
    };
    }
    
    document.addEventListener("click", function (e) {
    var count = 14;
    for (var p = 0; p < count; p++) {
    spawnPowderParticle(e.clientX, e.clientY);
    }
    });
    }
    
    /* ---------- Font credit (commercial license attribution) ---------- */
    function initFontCredit() {
    var footer = document.querySelector("footer");
    if (!footer) return;
    if (document.querySelector(".matcha-font-credit")) return;
    
    var credit = document.createElement("div");
    credit.className = "matcha-font-credit";
    credit.textContent = "The font used is Little Kids Handwriting. All rights are reserved by Cloudy's Fonts. Available at dafont.com";
    footer.appendChild(credit);
    }
    /* ---------- Logo scroll effect ---------- */
    /* ---------- Hand-drawn icon filter ---------- */
function initHandDrawnIcons() {
  if (document.getElementById("hand-drawn-filter-defs")) return;
  var svgNS = "http://www.w3.org/2000/svg";
  var svg = document.createElementNS(svgNS, "svg");
  svg.setAttribute("id", "hand-drawn-filter-defs");
  svg.setAttribute("width", "0");
  svg.setAttribute("height", "0");
  svg.style.position = "absolute";
  svg.innerHTML =
    '<filter id="hand-drawn-filter" x="-30%" y="-30%" width="160%" height="160%">' +
    '<feTurbulence type="fractalNoise" baseFrequency="0.09" numOctaves="2" seed="7" result="noise"/>' +
    '<feDisplacementMap in="SourceGraphic" in2="noise" scale="2.5"/>' +
    "</filter>";
  document.body.appendChild(svg);
}
  /* ---------- Logo scroll effect ---------- */
function initLogoScrollEffect() {
  var logo = document.querySelector(".header-logo__image");
  if (!logo) return;
  if (reduceMotion) return;

  var scroller = document.querySelector(".page-wrapper") || window;

  function getScrollY() {
    return scroller === window ? (window.scrollY || window.pageYOffset) : scroller.scrollTop;
  }

  function updateLogo() {
    var scrollY = getScrollY();
    var progress = Math.min(scrollY / 200, 1);
    var scale = 1 - progress * 0.25;
    var translate = progress * -6;
    logo.style.transform = "scale(" + scale.toFixed(3) + ") translateY(" + translate.toFixed(1) + "px)";
  }

  scroller.addEventListener("scroll", updateLogo, { passive: true });
  updateLogo();
}
/* ---------- Remove $ from displayed prices ---------- */
function initRemoveDollarSign() {
  var selectors = ".price, .fsb_symbol, .fsb_visually-hidden";
  function stripDollar(root) {
    (root || document).querySelectorAll(selectors).forEach(function (el) {
      if (el.textContent.indexOf("$") !== -1) {
        el.textContent = el.textContent.replace(/\$/g, "");
      }
    });
  }
  stripDollar();

  var observer = new MutationObserver(function () {
    stripDollar();
  });
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
}
/* ---------- Homepage story section (after Featured Collection) ---------- */
function initHomeStorySection() {
  var anchor = document.getElementById("shopify-section-template--23019790991618__product_list_fa6P9H");
  if (!anchor) return;
  if (document.querySelector(".matcha-story-section")) return;

  var wrapper = document.createElement("div");
  wrapper.innerHTML =
    '<section class="matcha-story-section">' +
      '<div class="matcha-story-section__text">' +
        '<h2 class="matcha-story-section__heading">make your matcha a little more you</h2>' +
        '<p class="matcha-story-section__body">every habiyo set starts as a hand-drawn idea, a small reminder that meets you where you\'re at. we make them so picking your ritual feels like picking yourself.</p>' +
        '<a href="/pages/about-habiyo" class="matcha-story-section__button">about us</a>' +
      '</div>' +
      '<div class="matcha-story-section__photos">' +
        '<img class="matcha-story-section__photo matcha-story-section__photo--1" src="https://cdn.shopify.com/s/files/1/0833/8807/2194/files/image_969ff2d7-e333-40d5-a10a-0bea0b9c4b82.png?v=1788070875" alt="tulip field">' +
        '<img class="matcha-story-section__photo matcha-story-section__photo--2" src="https://cdn.shopify.com/s/files/1/0833/8807/2194/files/image_3dbca93a-9af4-4f4c-acf9-28823cf4b202.png?v=1788070874" alt="full moon">' +
        '<img class="matcha-story-section__photo matcha-story-section__photo--3" src="https://cdn.shopify.com/s/files/1/0833/8807/2194/files/image.png?v=1788070874" alt="matcha sieve beads sketch">' +
        '<img class="matcha-story-section__photo matcha-story-section__photo--4" src="https://cdn.shopify.com/s/files/1/0833/8807/2194/files/image_9d95632e-a7e9-484b-9cfa-01d4bb48f3be.png?v=1788070874" alt="nami the cat">' +
        '<span class="matcha-story-section__note matcha-story-section__note--1">stay playful ♡</span>' +
        '<span class="matcha-story-section__note matcha-story-section__note--2">enjoy your youth ✦</span>' +
        '<span class="matcha-story-section__note matcha-story-section__note--3">feed your inner child</span>' +
      '</div>' +
    '</section>';

  anchor.parentNode.insertBefore(wrapper.firstElementChild, anchor.nextSibling);
}
/* ---------- Homepage story section (after Featured Collection) ---------- */
function initHomeStorySection() {
  var anchor = document.getElementById("shopify-section-template--23019790991618__product_list_fa6P9H");
  if (!anchor) return;
  if (document.querySelector(".matcha-story-section")) return;

  var wrapper = document.createElement("div");
  wrapper.innerHTML =
    '<section class="matcha-story-section">' +
      '<div class="matcha-story-section__text">' +
        '<h2 class="matcha-story-section__heading">make your matcha a little more you</h2>' +
        '<p class="matcha-story-section__body">every habiyo set starts as a hand-drawn idea, a small reminder that meets you where you\'re at. we make them so picking your ritual feels like picking yourself.</p>' +
        '<a href="/pages/about-habiyo" class="matcha-story-section__button">about us</a>' +
      '</div>' +
      '<div class="matcha-story-section__photos">' +
        '<img class="matcha-story-section__photo matcha-story-section__photo--1" src="https://cdn.shopify.com/s/files/1/0833/8807/2194/files/image_969ff2d7-e333-40d5-a10a-0bea0b9c4b82.png?v=1788070875" alt="tulip field">' +
        '<img class="matcha-story-section__photo matcha-story-section__photo--2" src="https://cdn.shopify.com/s/files/1/0833/8807/2194/files/image_3dbca93a-9af4-4f4c-acf9-28823cf4b202.png?v=1788070874" alt="full moon">' +
        '<img class="matcha-story-section__photo matcha-story-section__photo--3" src="https://cdn.shopify.com/s/files/1/0833/8807/2194/files/image.png?v=1788070874" alt="matcha sieve beads sketch">' +
        '<img class="matcha-story-section__photo matcha-story-section__photo--4" src="https://cdn.shopify.com/s/files/1/0833/8807/2194/files/image_9d95632e-a7e9-484b-9cfa-01d4bb48f3be.png?v=1788070874" alt="nami the cat">' +
      '</div>' +
    '</section>';

  anchor.parentNode.insertBefore(wrapper.firstElementChild, anchor.nextSibling);
}
/* ---------- Scroll animations: collection media + story section ---------- */
function initCollectionMediaReveal() {
  var mediaEls = document.querySelectorAll("#shopify-section-template--23019790991618__product_list_fa6P9H .product-media");
  if (!mediaEls.length) return;
  if (reduceMotion || !("IntersectionObserver" in window)) {
    mediaEls.forEach(function (m) { m.classList.add("is-revealed"); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var idx = Array.prototype.indexOf.call(mediaEls, entry.target);
        setTimeout(function () { entry.target.classList.add("is-revealed"); }, idx * 120);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });
  mediaEls.forEach(function (el) { observer.observe(el); });
}

function initStoryHeadingTypewriter() {
  var heading = document.querySelector(".matcha-story-section__heading");
  if (!heading) return;
  var fullText = heading.textContent;
  heading.setAttribute("data-typewriter", "");
  if (reduceMotion || !("IntersectionObserver" in window)) return;
  var started = false;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting && !started) {
        started = true;
        heading.textContent = "";
        heading.classList.add("is-typing");
        var charIndex = 0;
        function typeNext() {
          if (charIndex <= fullText.length) {
            heading.textContent = fullText.slice(0, charIndex);
            charIndex++;
            setTimeout(typeNext, 55);
          } else {
            heading.classList.remove("is-typing");
          }
        }
        typeNext();
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.4 });
  observer.observe(heading);
}

function initStoryPhotosReveal() {
  var photos = document.querySelectorAll(".matcha-story-section__photo");
  var container = document.querySelector(".matcha-story-section__photos");
  if (!photos.length || !container) return;
  if (reduceMotion || !("IntersectionObserver" in window)) {
    photos.forEach(function (p) { p.classList.add("is-revealed"); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        photos.forEach(function (photo, i) {
          setTimeout(function () { photo.classList.add("is-revealed"); }, i * 150);
        });
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });
  observer.observe(container);
}
/* ---------- Hero: sifter animation ---------- */
function initHeroSifterAnimation() {
  var heroContainer = document.querySelector("#shopify-section-template--23019790991618__hero_jVaWmY .hero__container");
  var heroEl = document.querySelector("#shopify-section-template--23019790991618__hero_jVaWmY .hero");
  if (!heroContainer || !heroEl) return;
  if (document.querySelector(".hero-sifter-wrap")) return;

  var sifterWrap = document.createElement("div");
  sifterWrap.className = "hero-sifter-wrap";
  sifterWrap.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0833/8807/2194/files/image_19e86a23-3060-43f4-acb9-f4662f4dc829.png?v=1788074351" alt="matcha sifter">';
  heroContainer.insertBefore(sifterWrap, heroContainer.firstChild);

  if (reduceMotion) return;

  function spawnHeroPowder() {
    var heroRect = heroEl.getBoundingClientRect();
    var sifterRect = sifterWrap.getBoundingClientRect();
    var startY = sifterRect.bottom - heroRect.top - 30;
    var startXCenter = (sifterRect.left + sifterRect.right) / 2 - heroRect.left;
    var endY = heroRect.height * 0.98;

    var particle = document.createElement("div");
    particle.className = "hero-powder-particle";
    var size = 3 + Math.random() * 5;
    var startX = startXCenter + (Math.random() - 0.5) * 90;
    particle.style.width = size + "px";
    particle.style.height = size + "px";
    particle.style.left = startX + "px";
    particle.style.top = startY + "px";
    heroEl.appendChild(particle);

    var offsetX = (Math.random() - 0.5) * 50;
    var fallDistance = endY - startY + (Math.random() - 0.5) * 20;
    var duration = 1200 + Math.random() * 800;
    var rotate = Math.random() * 360;
    var anim = particle.animate(
      [
        { transform: "translate(0px, 0px) rotate(0deg)", opacity: 0.95 },
        { transform: "translate(" + offsetX + "px, " + fallDistance + "px) rotate(" + rotate + "deg)", opacity: 0 }
      ],
      { duration: duration, easing: "cubic-bezier(0.4, 0.1, 0.6, 1)" }
    );
    anim.onfinish = function () {
      particle.remove();
    };
  }

  setInterval(spawnHeroPowder, 180);
}
    if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ready);
    } else {
    ready();
    }

    function ready() {
 initScrollReveal();
  initTypewriter();
  initMatchaPowderClick();
  initFontCredit();
  initHandDrawnIcons();
  initLogoScrollEffect();
    initRemoveDollarSign();
           initHomeStorySection();
           initCollectionMediaReveal();
initStoryHeadingTypewriter();
initStoryPhotosReveal();
    }
    })();
    